import sortBy from 'lodash/sortBy';
import React from 'react';
import * as PropTypes from 'prop-types';
import { formatCurrency } from '../../../helpers/formatters';

export function handleFilter(id, items, macro = null) {
    return items.map(order => {
        const { orders } = order;

        const filteredOrders = orders.map(row => {
            const { order_rows } = row;

            const filtered =
                macro !== null
                    ? order_rows.reduce((prev, order) => {
                          if (order.macros != null
                              && order.macros.includes(id)) {
                              prev.push({
                                  ...order
                              });
                          }

                          return prev;
                      }, [])
                    : order_rows.reduce((prev, order) => {
                          if (id === order.article_code) {
                              prev.push({
                                  ...order
                              });
                          }

                          return prev;
                      }, []);

            return {
                ...row,
                order_rows: filtered
            };
        });

        return {
            ...order,
            orders: filteredOrders,
            totalFiltered: getOrderTotal(filteredOrders, 'article_total')
        };
    });
}

export function getOrderTotal(
    orders,
    field,
    isFilteredWithArticle = false,
    article_id = null
) {
    if (isFilteredWithArticle) {
        return orders.reduce((prev, order) => {
            return (
                prev +
                order.order_rows.reduce((acc, row) => {
                    if (row.article_code === article_id) {
                        return acc + row[field];
                    }

                    return acc;
                }, 0)
            );
        }, 0);
    }

    return orders.reduce((prev, order) => {
        return (
            prev + order.order_rows.reduce((acc, row) => acc + row[field], 0)
        );
    }, 0);
}

export function getOrderedItems(handledItems, sortLabel, sortDirection) {
    let items = sortBy(handledItems, sortLabel);

    if (sortDirection === 'DESC') {
        items = items.reverse();
    }

    return items;
}

const HOTEL_CUSTOMER_CATEGORY_LABELS = {
    'ff38ce96-268f-4a14-b4d7-d64bd9615b1b': 'Base',
    'd144237c-75bb-4f10-8102-d2792dfb68f4': 'Plus',
    '3bbaa7b5-8180-4ef8-897d-77d20d0b3d9d': 'Potenziale top',
    'b67a6950-da85-4bd9-aaad-f8c8e5ddf0ac': 'Top',
    '9c9c01ce-3943-4644-8ae6-a1635f8e0b15': 'Azienda'
};

export function getHotelCustomerCategoryLabel(hotelCustomerCategory) {
    return HOTEL_CUSTOMER_CATEGORY_LABELS[hotelCustomerCategory] || '';
}

export function getOldestOrderDate(orders) {
    if (!orders || orders.length === 0) {
        return null;
    }

    const mutableOrders = toMutableItems(orders);
    const dates = [];

    for (let i = 0; i < mutableOrders.length; i++) {
        const order = mutableOrders[i];
        const hasRows = !order.order_rows || order.order_rows.length > 0;

        if (!hasRows) {
            continue;
        }

        const date = order.order_date || order.order_creation_date;

        if (date) {
            dates.push(date);
        }
    }

    dates.sort();

    return dates[0] || null;
}

export function getHotelLocalita(item, localitaByHotelId = {}) {
    if (!item) {
        return '';
    }

    if (item.nome_posizione) {
        return item.nome_posizione;
    }

    if (item.hotel_city) {
        return item.hotel_city;
    }

    const hotelId = item.hotel_id;
    const fromMap =
        localitaByHotelId[hotelId] ||
        localitaByHotelId[String(hotelId)] ||
        localitaByHotelId[Number(hotelId)];

    if (fromMap) {
        return fromMap;
    }

    const orders = item.orders || [];

    for (let i = 0; i < orders.length; i++) {
        if (orders[i].nome_posizione) {
            return orders[i].nome_posizione;
        }

        if (orders[i].hotel_city) {
            return orders[i].hotel_city;
        }
    }

    return '';
}

export function enrichVendutoRow(item, localitaByHotelId = {}) {
    return {
        ...item,
        first_order_date: getOldestOrderDate(item.orders),
        hotel_city: getHotelLocalita(item, localitaByHotelId)
    };
}

export function toMutableItems(items) {
    if (!items) {
        return [];
    }

    if (typeof items.asMutable === 'function') {
        return items.asMutable({ deep: true });
    }

    return items;
}

export function renderDiffCell(
    totalKey,
    listTotalKey,
    isFilteredWithMacro = false,
    isFilteredWithArticle = false,
    article_id = null
) {
    return function DiffCell({ rowData }) {
        const total =
            !isFilteredWithMacro && !isFilteredWithArticle
                ? rowData[totalKey]
                : isFilteredWithArticle
                ? getOrderTotal(rowData.orders, totalKey, true, article_id)
                : getOrderTotal(rowData.orders, totalKey);

        const list_total =
            !isFilteredWithMacro && !isFilteredWithArticle
                ? rowData[listTotalKey]
                : isFilteredWithArticle
                ? getOrderTotal(rowData.orders, listTotalKey, true, article_id)
                : getOrderTotal(rowData.orders, listTotalKey);

        const diff = total - list_total;
        const perc = list_total > 0 ? 100 - (total * 100) / list_total : -100;

        if (diff === 0) {
            return <span>-</span>;
        }

        const diffClass = diff > 0 ? 'text-success' : 'text-danger';

        return (
            <span className={diffClass}>
                {formatCurrency(diff)} / {perc.toFixed(2) * -1} %
            </span>
        );
    };
}

renderDiffCell.propTypes = {
    rowData: PropTypes.object
};
